import ReportsPageSectionsWrapperView  from './reports-page-sections-wrapper-view'

export default ReportsPageSectionsWrapperView
